import './Operations.css';
import { IonIcon, IonItem, IonLabel, IonNote, IonText } from "@ionic/react";
import {magnetOutline, removeOutline} from "ionicons/icons";
import moment from "moment";
import {Asset, DisplayableOperation} from "../../types/types";
import NumberFormat from "react-number-format";
import { useTranslation } from 'react-i18next';

interface PaymentProps {
  operation: DisplayableOperation;
  onClick:Function;
  asset:Asset
}

/**
 * 
 * On this component we are having a mix of information. In case the account is a recipient, we display the 
 * claimable balance information for the user to claim its balance. However, if the account is a sender
 * we just display it as a payment because from the sender perspective that is a payment that it was sent 
 * and nothing else needs to be done 
 */

const CreateClaimableBalanceListItem: React.FC<PaymentProps> = ({operation,asset,onClick}) => {

const { t, i18n } = useTranslation();


  return (

    <IonItem lines='none'className='operationsItem' onClick={()=>{onClick()}}>

        <IonIcon slot="start"
         
            icon={operation.isRecipient?magnetOutline:removeOutline} color='medium'
        />
         
        <IonLabel>
            <IonText className="ion-text-wrap">
            
            <h5>
                {
                    operation.isRecipient?t('operations.createclaimablebalance.CLAIM-LABEL'):t('operations.payment.SEND-LABEL')
                }
                    
            </h5>
         
            </IonText>
            <IonNote className="operationsItem_IonNote">
                {moment.unix(operation.timestamp).format("D MMM YYYY")}
            </IonNote>
        </IonLabel>
        
        <IonLabel slot='end' className='operationsItem_Amount'> 
                           
            <IonText color={operation.isRecipient?'medium':"danger"} className="ion-text-wrap">

                <h5>
                    <NumberFormat value = {operation.amount.toString()} 
                        prefix= {operation.isRecipient?"+ ":"- "} 
                        displayType={'text'} 
                        thousandSeparator={true} 
                        decimalSeparator="." 
                        decimalScale ={asset.decimal_places} 
                        fixedDecimalScale = {true} 
                        suffix={` ${asset.display_code}`}
                    /> 
                
                </h5>

            </IonText>
    
        </IonLabel> 

    </IonItem>
  );
};

export default CreateClaimableBalanceListItem;